/**
* Created by bieao on 2020/5/23.
*/
<template>
  <div class="item-position" id="qunCrane"></div>
</template>

<script>
// 蓝色是Z，绿色是Y  红色是X
// m
import Crane from '../common/Crane'
// const modelScale = 0.126
const modelScale = 0.253
const biaoZhunJieHeight = 2.5

export default {
  name: 'ThreeDQunCraneTwo',
  data () {
    return {
      width: 1920,
      height: 1080,
      planeXY: 0,
      renderer: null,
      scene: null,
      camera: null,
      controls: null,
      stats: null,
      allThings: new THREE.Group(), // 3D界面所有的东西 -> 调整整个塔吊和地面的位置
      allCranes: new THREE.Group(), // 所有的塔机 -> 调整塔吊到合适的位置
      cranesArr: [],
      timeRequest: 2, // 2秒请求一次
      cranesStep: {}, // 每一个执行的步长
      oldRunData: {},
      canvasScale: 0, // canvas和实际的比例换算
      craneHeightObj: {},
      craneArray: {}, // 塔机的实例
      plane: new THREE.Mesh()
    }
  },
  props: {
    cranes: {
      type: Array
    },
    config: {
      type: Object
    },
    runData: {
      type: Array
    },
    screenChange: {
      type: Number
    }
  },
  watch: {
    config (val, oldVal) {
      if (val !== oldVal) {
        this.draw()
      }
    },
    cranes (val, oldVal) {
      if (val !== oldVal) {
        this.initAllCrane()
      }
    },
    runData (val, oldVal) {
      if (val !== oldVal) {
        this.updateCrane()
      }
    },
    screenChange (val, oldVal) {
      if (val !== oldVal) {
        this.camera.aspect = window.innerWidth / window.innerHeight
        this.camera.updateProjectionMatrix()
      }
    }
  },
  methods: {
    /* 计算地面大小 */
    calcPlaneSize () {
      const {width, height} = this.config
      const max = Math.max(width, height)
      this.planeXY = modelScale * 155 / biaoZhunJieHeight * max
    },
    /* 初始化渲染器 */
    initRender () {
      this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true})
      this.renderer.setPixelRatio(window.devicePixelRatio) // 设置为浏览器的像素比
      this.renderer.setSize(this.width, this.height) // 设置窗口大小
      document.getElementById('qunCrane').appendChild(this.renderer.domElement)
    },
    /* 初始化场景 */
    initScene () {
      this.scene = new THREE.Scene()
    },
    initStats () {
      this.stats = new Stats()
      document.body.appendChild(this.stats.dom)
    },
    /* 初始化摄像头 */
    initCamera () {
      const view_angle = 45, // 垂直方向上的视野夹角
        aspect = window.innerWidth / window.innerHeight, // 可视区域宽高比
        near = 0.1, // 近距
        far = 100000 // 远距离
      this.camera = new THREE.PerspectiveCamera(view_angle, aspect, near, far) // 透视相机
      this.camera.position.set(0.49 * this.planeXY, 500, 0.63 * this.planeXY) // 相机的位置
      this.camera.lookAt(new THREE.Vector3(0, -500, 0)) // 机头的朝向
    },
    /* 初始化光源 */
    initLight () {
      const position = 0.82 * this.planeXY
      this.scene.add(new THREE.AmbientLight(0xffffff)) // THREE.AmbientLight属于全局光
      const pointLight = new THREE.PointLight(0xffffff, 0.9, 0) // 添加点光源
      pointLight.position.set(0, 1000, position)
      this.scene.add(pointLight)
      const pointLight1 = new THREE.PointLight(0xffffff, 0.9, 0) // 添加点光源
      pointLight1.position.set(0, 1000, -position)
      this.scene.add(pointLight1)
      const pointLight2 = new THREE.PointLight(0xffffff, 0.9, 0) // 添加点光源
      pointLight2.position.set(position, 1000, 0)
      this.scene.add(pointLight2)
      const pointLight3 = new THREE.PointLight(0xffffff, 0.9, 0) // 添加点光源
      pointLight3.position.set(-position, 1000, 0)
      this.scene.add(pointLight3)
    },
    /* 添加辅助坐标 */
    initCoordinate () {
      const helper = new THREE.AxesHelper(50)
      this.scene.add(helper)
    },
    /* 添加地面 */
    addPlane () {
      let loader = new THREE.TextureLoader()
      let texture = loader.load(`/static/img/bg.png`)
      let material = new THREE.MeshBasicMaterial({map: texture, side: THREE.DoubleSide})
      const {width, height} = this.config
      const max = Math.max(width, height)
      const value = modelScale * 155 / biaoZhunJieHeight * max
      this.planeXY = value
      let planeGeometry = new THREE.PlaneGeometry(value, value)
      this.plane = new THREE.Mesh(planeGeometry, material)
      this.plane.rotation.x = -0.5 * Math.PI
      this.plane.position.y = -540
      this.plane.name = 'plane'
      this.scene.add(this.plane)
      // 添加指北针
      let compassLoad = new THREE.TextureLoader()
      let compassTexture = compassLoad.load(`/static/img/zhiBeiZhen.png`)
      let compassMaterial = new THREE.MeshBasicMaterial({map: compassTexture})
      compassMaterial.transparent = true
      let compassGeometry = new THREE.PlaneGeometry(200, 700)
      let compass = new THREE.Mesh(compassGeometry, compassMaterial)
      compass.rotation.x = -0.5 * Math.PI
      compass.position.y = -510
      compass.name = 'plane'
      this.scene.add(compass)
    },
    // 工地和3D比例的换算
    resolveScale () {
      const {width, height, maxBorderX, maxBorderY} = this.config
      const scaleX = this.planeXY / width
      const scaleY = this.planeXY / height
      // 算出移动的距离
      const centerX = width / 2
      const disX = maxBorderX - centerX
      const centerY = height / 2
      const disY = maxBorderY - centerY
      const scale = Math.min(scaleX, scaleY)
      this.canvasScale = scale
      return {scale, disX, disY} // 选出比例小的
    },
    // 循环初始化塔机
    initAllCrane () {
      const {scale, disX, disY} = this.resolveScale()
      const len = this.cranes.length
      this.initCrane(scale, disX, disY, 0, len)
    },
    initCrane (scale, disX, disY, index, len) {
      const currentCrane = this.cranes[index]
      const {craneId, screenX, screenY, armLength, balanceArmLength, towerHeight, areaList} = currentCrane
      const newScreenX = screenX * scale
      const newScreenY = screenY * scale
      const newArmLength = armLength * scale
      const newBalanceArmLength = balanceArmLength * scale
      const newTowerHeight = towerHeight * scale
      if (areaList.length) {
        areaList.forEach((area) => {
          const newPointVoList = area.pointVoList.map((point) => {
            const {x, y} = point
            return {x: (x * scale - newScreenX), y: (y * scale - newScreenY)}
          })
          Object.assign(area, {pointVoList: newPointVoList})
        })
      }
      const newRes = {
        screenX: newScreenX,
        screenY: newScreenY,
        armLength: newArmLength,
        balanceArmLength: newBalanceArmLength,
        towerHeight: newTowerHeight
      }
      const crane = new Crane(modelScale)
      crane.initCrane({...currentCrane, ...newRes}, () => {
        this.allCranes.add(crane.craneGroup)
        this.craneArray[craneId] = {crane, newScreenX, newScreenY}
        const canvasX = -disX * scale
        const canvasY = -disY * scale
        this.allCranes.position.set(canvasX, 0, canvasY)
        this.allCranes.position.y = -500
        this.scene.add(this.allCranes)
        index++
        if (index < len) {
          this.initCrane(scale, disX, disY, index, len)
        } else {
          this.$emit('initFinish')
        }
      })
    },
    updateCrane() {
      this.runData.forEach((res) => {
        const current = this.craneArray[res.craneId]
        const {crane} = current
        const {height, radius} = res
        const canvasHeight = height * this.canvasScale
        const canvasRadius = radius * this.canvasScale
        crane.update({...res, ...{orgHeight: height, height: canvasHeight, orgRadius: radius, radius: canvasRadius}})
      })
    },
    addClickEvent () {
      let raycaster = new THREE.Raycaster()
      let mouse = new THREE.Vector2()
      const self = this
      window.addEventListener('click', (event) => {
        let name = ''
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
        raycaster.setFromCamera(mouse, self.camera)
        let intersects = raycaster.intersectObjects(self.allCranes.children, true)
        for (let i = 0; i < intersects.length; i++) {
          if (intersects[ i ].object.name !== 'plane') {
            if (name !== intersects[ i ].object.name) {
              name = intersects[ i ].object.name
            }
          }
        }
        if (name) {
          this.$emit('getClickCrane', name)
        }
      }, false)
    },
    calcCameraPosition () {
      if (this.camera) {
        let angle = 0
        const {x, z} = this.camera.position
        if (x > 0) {
          // 右下角
          if (z > 0) {
            angle = Math.atan(x / z)
          } else if (z === 0) {
            angle = Math.PI * 0.25
          } else {
            angle = Math.PI - Math.atan(x / Math.abs(z))
          }
        } else if (x < 0) {
          if (z > 0) {
            angle = 2 * Math.PI - Math.atan(Math.abs(x) / z)
          } else if (z === 0) {
            angle = 1.5 * Math.PI
          } else {
            angle = Math.PI + Math.atan(Math.abs(x) / Math.abs(z))
          }
        }
        for (let key in this.craneArray) {
          const crane = this.craneArray[key].crane
          crane.infoPlaneGroup.rotation.y = angle
          crane.craneNameMesh.rotation.y = angle
          crane.craneDriverGroup.rotation.y = angle
          crane.craneCameraGroup.rotation.y = angle
        }
      }
    },
    /* 重新渲染 */
    render () {
      this.calcCameraPosition()
      this.renderer.render(this.scene, this.camera)
    },
    /* 初始控件 */
    initControls () {
      this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement)
      // 如果使用animate方法时，将此函数删除
      // controls.addEventListener( 'change', render );
      // 使动画循环使用时阻尼或自转 意思是否有惯性
      this.controls.enableDamping = true
      // 动态阻尼系数 就是鼠标拖拽旋转灵敏度
      // controls.dampingFactor = 0.25;
      // 是否可以缩放
      this.controls.enableZoom = true
      // 是否自动旋转
      this.controls.autoRotate = false
      this.controls.autoRotateSpeed = 0.2
      // 设置相机距离原点的最远距离
      this.controls.minDistance = 1
      // 设置相机距离原点的最远距离
      this.controls.maxDistance = 100000
      // 是否开启右键拖拽
      this.controls.enablePan = true
      // this.controls.maxPolarAngle = 0.5 * Math.PI
    },
    /* 添加动画 */
    animate () {
      this.render()
      // this.stats.update()
      requestAnimationFrame(this.animate)
    },
    /* 画图 */
    draw () {
      this.calcPlaneSize()
      this.initRender()
      this.initScene()
      // this.initStats()
      this.initCamera()
      this.initLight()
      // this.initCoordinate()
      this.addPlane()
      this.initControls()
      this.animate()
      this.addClickEvent()
    }
  },
  mounted () {
    // this.draw()
  }
}
</script>

<style scoped lang="scss">
  #qunCrane{
    z-index:1;
    left:0;
    top:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThreeDQunCraneTwo.vue